module.exports = __webpack_public_path__ + "media/images/flags/gp-08cc3d929fe9fd7fe1bd23a9596a74ec.svg";